<template>
  <div style="height: 100vh;background-color: #ffffff;">
    <div class="navbar nav-main w-100" style="background-color:#23409A;color:white">
      <h3 class="w-100 text-center my-3">เช็คยอด</h3>
    </div>
    <div class="session-with-nav ">
      <CheckUnRegised />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import CheckUnRegised from "@/components/checkbalance/checkUnRegised";
export default {
  components: { CheckUnRegised },
  data() {
    return {
      userData: null,
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
    profile() {
      return this.$store.state.profile;
    },
    userId() {
      return this.$store.state.profile.userId;
    },
    regised() {
      if (this.userId && this.userData && this.userData.cardnumber) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
  mounted() {
    //   this.setup()
  },
  methods: {
    // async setup() {
    //   await this.fetchUserData(this.userId);
    // },
    close() {
      this.$liff.closeWindow();
    },
    // async fetchUserData(userId) {
    //   if (userId) {
    //     let res = await api.getUser(userId);
    //     if (res.responsecode == 200 && res.data.id) {
    //       this.userData = res.data;
    //     } else {
    //       console.log("error fetch user data");
    //     }
    //   }
    // },
  },
};
</script>

<style></style>
